import { Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DevicesComponent } from './components/devices/devices.component';
import { SessionDetailComponent } from './components/session-detail/session-detail.component';
import { ViewerComponent } from './components/viewer/viewer.component';
import { SessionsComponent } from './components/sessions/sessions.component';
import { LogsListComponent } from './components/logs-list/logs-list.component';
import { LogDetailComponent } from './components/log-detail/log-detail.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { OrganizationDetailComponent } from './components/organizations/organization-detail.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'organizations', component: OrganizationsComponent },
      { path: 'organizations/:id', component: OrganizationDetailComponent },
      { path: 'sessions', component: SessionsComponent },
      { path: 'logs', component: LogsListComponent },
      { path: 'logs/:id', component: LogDetailComponent },
      { 
        path: 'app-models', 
        loadComponent: () => import('./components/app-models/app-models.component').then(m => m.AppModelsComponent) 
      },
      { path: 'devices', component: DevicesComponent },
      { path: 'session/:id', component: SessionDetailComponent },
      { path: 'viewer/:id', component: ViewerComponent },
    ]
  },
];
